import { createFileRoute } from '@tanstack/react-router';

import { EditSessionPage } from '~pages/sessions/edit-session-page';

export const Route = createFileRoute('/_auth/_layout/sessions/$sessionId/edit')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { sessionId } = Route.useParams();
  return <EditSessionPage sessionId={sessionId} />;
}
